<template>
  <div class="viewDialog">
    <div class="dialogMain">
      <el-alert
        v-show="tipError.show"
        :title="tipError.message"
        type="error"
        show-icon
        class="tipError"
      />
      <el-form
        ref="handleForm"
        :model="handleForm"
        :rules="handleRules"
        label-position="right"
        label-width="150px"
      >
        <el-form-item label=" 通知标题：" prop="title">
          <el-input
            v-if=" dialogType==='add'"
            v-model="handleForm.title"
            name="title"
            placeholder="请输入通知标题"
            class="handle-form-input"
            maxlength="30"
          />
          <span v-else class="viewcontent">{{ content.title }}</span>
        </el-form-item>
        <el-form-item label=" 推送终端：" prop="desTerminalCode">
          <el-select
            v-if=" dialogType==='add'"
            v-model="handleForm.desTerminalCode"
            name="terminal"
            size="medium"
            class="handle-form-input"
            @change="gethandleFormTerminal"
          >
            <el-option
              v-for="item in terminaltypeArr"
              v-show="item.code === 'C01' || item.code === 'A02'"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
          <span v-else class="viewcontent">{{ content.desTerminalName }}</span>
        </el-form-item>
        <!-- <el-form-item label="推送角色：" prop="identityCode">
          <el-select
            multiple
            v-if=" dialogType==='add'"
            v-model="handleForm.identityCode"
            name="role"
            size="medium"
            class="handle-form-input"
            @change="gethandleFormType"
          >
            <el-option
              v-for="item in roletypeArr"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
          <span v-else class="viewcontent">{{content.identityName}}</span>
        </el-form-item>-->

        <el-form-item label="通知内容：" prop="content">
          <el-input
            v-if=" dialogType==='add'"
            v-model="handleForm.content"
            type="textarea"
            :rows="5"
            :show-word-limit="showlimit"
            :maxlength="maxlengthContent"
            placeholder="请输入通知内容"
            class="handle-form-input"
          />
          <!-- <Editor
            @editorChange="editorChangeFn"
            @editorChangeText="editorChangeTextFn"
            :editorContent="handleForm.content"
            v-if=" dialogType==='add'"
          /> -->
          <span v-else class="viewcontent ql-editor" v-html="content.content" />
        </el-form-item>
        <el-form-item label="跳转链接：" prop="link">
          <el-input
            v-if=" dialogType==='add'"
            v-model="handleForm.link"
            name="link"
            placeholder="请输入跳转链接"
            class="handle-form-input"
            maxlength="500"
          />
          <span v-else class="link">{{ content.link }}</span>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="dialogType==='view'" size="medium" type="primary" @click="closeDialog">
        关闭
      </el-button>
      <span v-else>
        <el-button size="medium" @click="closeDialog">取消</el-button>
        <el-button
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleAddNotice"
        >{{ ajaxLoading?'Loading':'确定' }}</el-button>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// 获取API
import {
  demandsensitivewordsCheck
} from '@/api/systemManage/sensitiveManage';
import {
  getDictsType,
  ReleaseNotices
} from '@/api/productOperation/mrDesk/myMessage';
export default {
  name: 'ViewDialog',
  // components: {
  //   Editor
  // },
  props: {
    content: {
      default: Object,
      type: Object
    },
    dialogType: {
      default: '',
      type: String
    }
  },
  data() {
    const validatortName = (rule, value, callback) => {
      // const pattern = new RegExp(/^[\u4e00-\u9fa5-_a-zA-Z0-9\uff1f\uff01\u3002\.\?\!]+$/);
      // else if (!pattern.test(value)) {
      //   callback(new Error('不能包含特殊字符'));
      // }
      if (!value) {
        callback(new Error('标题不能为空'));
      } else {
        var content = {
          content: value
        };
        demandsensitivewordsCheck(content).then(response => {
          if (response.data && response.data.isChoose) {
            callback(response.data.badword);
          } else {
            callback();
          }
        });
      }
    };
    return {
      ajaxLoading: false,
      // 错误提醒消息
      tipError: {
        show: false,
        message: '错误提示的文案'
      },

      // 操作表单
      handleForm: {
        id: '',
        title: '',
        // identityCode: '',
        desTerminalCode: '',
        content: '',
        link: ''
      },
      handleRules: {
        title: [
          { required: true, message: '通知标题不能为空', trigger: 'blur' },
          { trigger: 'blur', validator: validatortName }
        ],
        content: [
          { required: true, message: '通知内容不能为空', trigger: 'blur' }
        ],
        desTerminalCode: [
          { required: true, message: '推送终端不能为空', trigger: 'blur' }
        ]
      },
      listLoading: false, // 表格刷新loading
      multipleSelection: [], // 表格多选,
      advertisementList: [],
      roletypeArr: [],
      locatypeArr: [],
      terminaltypeArr: [],
      roletype: 'Identity_type',
      terminaltype: 'terminal_type',
      maxlengthContent: 200,
      showlimit: false
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'currentProdeuctId'])
  },

  mounted() {
    this.getType();
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog');
    },
    // 获取类型列表
    getType() {
      getDictsType(this.terminaltype).then(res => {
        this.terminaltypeArr = res.data;
      });
      getDictsType(this.roletype).then(res => {
        this.roletypeArr = res.data;
      });
    },
    // 推送角色选择
    gethandleFormType(val) {
      this.handleForm.identityCode = val;
    },
    // 推送终端选择
    gethandleFormTerminal(val) {
      this.showlimit = true;
      if (val === 'C01') {
        this.maxlengthContent = 200;
      } else {
        this.maxlengthContent = 50;
      }
      this.handleForm.desTerminalCode = val;
    },
    // 获取富文本带标签的内容
    editorChangeFn(val) {
      this.handleForm.content = val;
    },
    // 获取富文本纯文本
    editorChangeTextFn(val) {
      this.handleForm.content = val;
    },
    // 新增编辑通知
    handleAddNotice() {
      this.$refs['handleForm'].validate(valid => {
        if (valid) {
          var content = {
            content: this.handleForm.content
          };
          demandsensitivewordsCheck(content).then(response => {
            if (response.data && response.data.isChoose) {
              this.$message({
                type: 'warning',
                message: response.data.badword
              });
              return;
            } else {
              this.ajaxLoading = true;
              var option = {
                content: this.handleForm.content,
                productId: this.currentProdeuctId,
                // desIdentitys: this.handleForm.identityCode.join(','),
                desTerminalCode: this.handleForm.desTerminalCode,
                firstTypeCode: 1,
                isPush: 1,
                noticeOutDTOList: [
                  {
                    orgCode: this.userInfo.orgCode,
                    sendCode: this.userInfo.code
                  }
                ],
                title: this.handleForm.title,
                link: this.handleForm.link
              };
              ReleaseNotices(option)
                .then(res => {
                  this.$notify.success({
                    title: 'Success',
                    message: '发布成功',
                    showClose: false,
                    duration: 2000
                  });
                  this.$emit('handleAddNotice');
                })
                .catch(res => {
                  // this.tipError.message = res.data.resultMessage;
                  // this.tipError.show = true;
                  // setTimeout(() => {
                  //   this.tipError.message = "";
                  //   this.tipError.show = false;
                  // }, 1000);
                  this.ajaxLoading = false;
                });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.viewDialog {
  .dialogMain {
    max-height: 470px;
    overflow-y: auto;
  }
}
.handle-form-input {
  width: 80%;
}
.tipError {
  margin-bottom: 10px;
}
.dialog-footer {
  text-align: right;
}

</style>

